// src/pages/RegisterPatient.jsx
import nooLogo from '../assets/noo.png';
import picImage from '../assets/pic.png';
import uploadIcon from '../assets/upload.png';
import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { FaBars, FaTimes } from 'react-icons/fa';


const RegisterPatient = () => {
  const location = useLocation();
  const [activeTab, setActiveTab] = useState('Information');
  const [isNavbarOpen, setIsNavbarOpen] = useState(false);
  // State for attachment previews
  const [attachment1Preview, setAttachment1Preview] = useState(uploadIcon);
  const [attachment2Preview, setAttachment2Preview] = useState(uploadIcon);
  // State for attachment textarea notes
  const [note1, setNote1] = useState('');
  const [note2, setNote2] = useState('');
  // State for diagnosis model image preview (the main image for classification/segmentation)
  const [diagnosisModelImage, setDiagnosisModelImage] = useState(uploadIcon);
  // State for the diagnosis model report
  const [modelReport, setModelReport] = useState('');
  // NEW: State for patient photo
  const [patientPhoto, setPatientPhoto] = useState(picImage);

  // State for Allergy section
  const [activeAllergenType, setActiveAllergenType] = useState('Drug'); // 'Drug', 'Food', 'Other'
  const [selectedDrugs, setSelectedDrugs] = useState([]);
  const [otherDrug, setOtherDrug] = useState('');
  const [selectedFoods, setSelectedFoods] = useState([]);
  const [otherFood, setOtherFood] = useState('');
  const [selectedOtherAllergens, setSelectedOtherAllergens] = useState([]);
  const [otherOtherAllergen, setOtherOtherAllergen] = useState('');
  const [selectedReactions, setSelectedReactions] = useState([]);
  const [otherReaction, setOtherReaction] = useState('');
  const [severity, setSeverity] = useState(''); // 'Mild', 'Moderate', 'Severe'
  const [allergyComment, setAllergyComment] = useState('');

  // State for SOAP Notes section
  const [subjectiveNote, setSubjectiveNote] = useState('');
  const [objectiveNote, setObjectiveNote] = useState('');
  const [assessmentNote, setAssessmentNote] = useState('');
  const [planNote, setPlanNote] = useState('');

  // NEW AI Model Enhancements States
  const [heatmapImage, setHeatmapImage] = useState(uploadIcon);
  const [heatmapComment, setHeatmapComment] = useState('');
  const [segmentationMaskImage, setSegmentationMaskImage] = useState(uploadIcon);
  const [segmentationMaskComment, setSegmentationMaskComment] = useState('');

  const patientId = "PAT-00123";
  const patientName = "John Doe";
  const lastPhotoUpdate = "2024-07-22";
  const toggleNavbar = () => {
    setIsNavbarOpen(!isNavbarOpen);
  };
  const openCity = (tabName) => {
    setActiveTab(tabName);
  };

  // Function to handle file selection for attachments
  const handleAttachmentFileChange = (event, setPreview) => {
    const file = event.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => {
        setPreview(reader.result);
      };
      reader.readAsDataURL(file);
    } else {
      setPreview(uploadIcon); // Reset to default upload icon if no file selected
    }
  };

  // Function to handle file selection for diagnosis model (main image)
  const handleDiagnosisModelFileChange = (event) => {
    const file = event.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => {
        setDiagnosisModelImage(reader.result);
        // Optionally, trigger model report generation here based on the selected image
        // For demonstration, we'll just clear the previous report and other AI outputs
        setModelReport('');
        setHeatmapImage(uploadIcon); // Clear heatmap preview
        setHeatmapComment(''); // Clear heatmap comment
        setSegmentationMaskImage(uploadIcon); // Clear segmentation preview
        setSegmentationMaskComment(''); // Clear segmentation comment
      };
      reader.readAsDataURL(file);
    } else {
      setDiagnosisModelImage(uploadIcon); // Reset to default upload icon if no file selected
      setModelReport(''); // Clear report if image is cleared
      setHeatmapImage(uploadIcon); // Clear heatmap preview
      setHeatmapComment(''); // Clear heatmap comment
      setSegmentationMaskImage(uploadIcon); // Clear segmentation preview
      setSegmentationMaskComment(''); // Clear segmentation comment
    }
  };

  // NEW: Function to handle heatmap image file selection
  const handleHeatmapFileChange = (event) => {
    const file = event.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => {
        setHeatmapImage(reader.result);
      };
      reader.readAsDataURL(file);
    } else {
      setHeatmapImage(uploadIcon);
    }
  };

  // NEW: Function to handle segmentation mask image file selection
  const handleSegmentationMaskFileChange = (event) => {
    const file = event.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => {
        setSegmentationMaskImage(reader.result);
      };
      reader.readAsDataURL(file);
    } else {
      setSegmentationMaskImage(uploadIcon);
    }
  };

  // NEW: Function to handle patient photo file selection
  const handlePatientPhotoChange = (event) => {
    const file = event.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => {
        setPatientPhoto(reader.result);
      };
      reader.readAsDataURL(file);
    }
  };

  // Function to clear attachment 1 form
  const clearAttachment1Form = () => {
    setAttachment1Preview(uploadIcon);
    setNote1(''); // Clear the textarea
  };

  // Function to clear attachment 2 form
  const clearAttachment2Form = () => {
    setAttachment2Preview(uploadIcon);
    setNote2(''); // Clear the textarea
  };

  // Function to simulate generating a report (replace with actual model call)
  const generateModelReport = () => {
    if (diagnosisModelImage === uploadIcon) {
      setModelReport('Please upload an image first to generate a report.');
      setHeatmapImage(uploadIcon); // Clear heatmap preview
      setHeatmapComment(''); // Clear heatmap comment
      setSegmentationMaskImage(uploadIcon); // Clear segmentation preview
      setSegmentationMaskComment(''); // Clear segmentation comment
      return;
    }
    // Simulate API call or model processing
    setModelReport(
      "Based on the analysis of the provided image, the model detected signs consistent with 'Mild Dermatitis'. Further clinical evaluation is recommended for confirmation. \n\nConfidence Score: 85%\nKey Features: Redness, slight swelling, no visible lesions."
    );
    // Simulate heatmap and segmentation mask generation
    setHeatmapImage('https://placehold.co/200x150/FF0000/FFFFFF?text=Heatmap+Simulated'); // Placeholder for heatmap
    setHeatmapComment('Heatmap shows areas of high activation around the affected region.');
    setSegmentationMaskImage('https://placehold.co/200x150/0000FF/FFFFFF?text=Mask+Simulated'); // Placeholder for segmentation mask
    setSegmentationMaskComment('Segmentation mask highlights the precise boundaries of the lesion.');
  };

  // Function to clear all model related outputs
  const clearModelReport = () => {
    setModelReport('');
    setDiagnosisModelImage(uploadIcon); // Clear main image
    setHeatmapImage(uploadIcon); // Clear heatmap preview
    setHeatmapComment(''); // Clear heatmap comment
    setSegmentationMaskImage(uploadIcon); // Clear segmentation preview
    setSegmentationMaskComment(''); // Clear segmentation comment
  };

  // Allergy Checkbox Handlers
  const handleAllergenCheckboxChange = (event, selectedList, setSelectedList, setOtherValue) => {
    const { value, checked } = event.target;
    if (value === 'Other') {
      // If "Other" checkbox is checked/unchecked, clear/reset its input
      if (!checked) setOtherValue('');
    }

    if (checked) {
      setSelectedList([...selectedList, value]);
    } else {
      setSelectedList(selectedList.filter((item) => item !== value));
    }
  };

  const handleReactionCheckboxChange = (event) => {
    const { value, checked } = event.target;
    if (value === 'Other') {
      if (!checked) setOtherReaction('');
    }

    if (checked) {
      setSelectedReactions([...selectedReactions, value]);
    } else {
      setSelectedReactions(selectedReactions.filter((item) => item !== value));
    }
  };

  const navLinks = [
    { name: 'Home', path: '/' },
    { name: 'Contact', path: '/contact' },
    { name: 'About', path: '/about' },
    { name: 'Register Patient', path: '/register-patient' },
  ];

  const drugAllergens = [
    'ACE inhibitors', 'ARBS (angiotensin II receptor blockers)', 'Aspirin', 'Cephalosporins',
    'Codeine', 'Erythromycins', 'Heparins', 'Morphine', 'NSAIDs', 'Penicillins',
    'Statins', 'Sulfonamides'
  ];

  const foodAllergens = [
    'Beef', 'Caffeine', 'Chocolate', 'Dairy food', 'Eggs', 'Fish', 'Milk Protein',
    'Peanuts', 'Shellfish', 'Soy', 'Strawberries', 'Wheat'
  ];

  const otherAllergens = [
    'Adhesive tape', 'Bee Stings', 'Dust', 'Latex', 'Mold', 'Pollen', 'Ragweed'
  ];

  const reactions = [
    'Unknown', 'Anaemia', 'Anaphylaxis', 'Angioedema', 'Arrhythmia', 'Bronchospasm',
    'Cough', 'Diarrhea', 'Dystonia', 'Fever', 'Flushing', 'GI upset', 'Headache',
    'Hepatotoxicity', 'Hives', 'Hypertension', 'Itching', 'Mental status change',
    'Musculoskeletal pain', 'Myalgia', 'Rash'
  ];


  return (
    <div className="min-h-screen bg-gray-100 min-w-screen font-['Segoe UI',_Tahoma,_Geneva,_Verdana,_sans-serif]">
      <div className="bg-white shadow-md py-4 px-6 mr-6 ml-6 flex items-center justify-between rounded-lg relative z-10"> {/* Added relative z-10 for mobile menu positioning */}
        <Link to="/">
          <img src={nooLogo} alt="Logo" className="h-12" />
        </Link>

        {/* Desktop Navigation Links */}
        <nav className="hidden md:flex space-x-8">
          {navLinks.map((link) => (
            <Link
              key={link.name}
              to={link.path}
              className={`font-bold text-lg px-4 py-2 transition-colors duration-200 ${
                location.pathname === link.path ? 'text-blue-500' : 'text-gray-700 hover:text-blue-500'
              }`}
            >
              {link.name}
            </Link>
          ))}
        </nav>

        {/* Mobile Menu Toggle Button */}
        <button
          className="md:hidden text-gray-700 focus:outline-none"
          onClick={toggleNavbar}
        >
          {isNavbarOpen ? (
            <FaTimes className="text-2xl" />
          ) : (
            <FaBars className="text-2xl" />
          )}
        </button>
      </div>

      {isNavbarOpen && (
        <nav className="md:flex block bg-white md:hidden flex-col md:flex-row items-center rounded-lg m-6 ">
          {navLinks.map((link) => (
            <Link
              key={link.name}
              to={link.path}
              className={`font-bold text-lg px-3 py-1 transition-colors duration-200 ${
                location.pathname === link.path ? 'text-blue-500' : 'text-gray-700 hover:text-blue-500'
              }`}
              onClick={() => setIsNavbarOpen(false)}
            >
              {link.name}
            </Link>
          ))}
        </nav>)}


      <div className="flex flex-col md:flex-row p-6">
        {/* Patient Image Section */}
        <div className="md:w-1/4 flex flex-col items-center p-4 bg-white rounded-lg shadow-md mb-6 md:mb-0 ">
          <div className="img-wrapper relative w-48 h-48 rounded-full overflow-hidden border-2 border-blue-400 flex items-center justify-center">
            {/* Hidden input for file selection */}
            <input
              type="file"
              id="patientPhotoUpload" // Unique ID for the patient photo input
              name="patientPhotoUpload"
              className="absolute inset-0 opacity-0 cursor-pointer z-10"
              onChange={handlePatientPhotoChange} // Handle file change
            />
            {/* Display patient photo */}
            <img src={patientPhoto} alt="Patient" className="w-full h-full object-cover" />
          </div>
          {/* Removed the old <p> tag for "Upload Patient Photo" */}
          {/* NEW: Button to trigger file upload */}
          <label
            htmlFor="patientPhotoUpload"
            className="inline-block mt-3 bg-blue-500 hover:bg-blue-600 text-white font-bold py-2 px-4 rounded-md cursor-pointer transition-colors duration-200"
          >
            Upload Patient Photo
          </label>
          <div className="flex flex-col mt-4 space-y-2">
            <Link to="/show-patient" className="text-blue-600 hover:underline text-md font-semibold">View Profile</Link>
          </div>
          <div className="flex flex-col items-center mt-4 text-gray-800">
            <p className="text-2xs font-semibold">
              Patient ID:{' '}
              <Link to={`/patient/${patientId}`} className="text-blue-600 hover:underline font-semibold">
                {patientId}
              </Link>
            </p>
            <p className="text-2xs font-semibold mt-1">
              Name:{' '}
              <Link to={`/patient/${patientId}/profile`} className="text-blue-600 hover:underline font-semibold">
                {patientName}
              </Link>
            </p>
            <p className="text-2xs text-gray-800 mt-2 font-semibold">Last photo updated: {lastPhotoUpdate}</p>
          </div>
        </div>


        {/* Tab Navigation */}
        <div className="md:w-3/4 md:ml-6 bg-white rounded-lg shadow-md p-4">
          <div className="flex flex-wrap justify-center md:justify-start border-b border-gray-200 mb-4">
            {/* Added 'SOAPNotes' to the tabs list */}
            {['Information', 'Capture', 'Diagnosis', 'Conditions', 'Allergy', 'SOAPNotes', 'Attachments', 'DiagnosisModel'].map((tab) => (
              <button
                key={tab}
                className={`px-4 py-2 text-sm md:text-base font-medium border-b-2 ${
                  activeTab === tab ? 'border-blue-500 text-blue-600' : 'border-transparent text-gray-700 hover:text-blue-500 hover:border-gray-300'
                } focus:outline-none transition-colors duration-200`}
                onClick={() => openCity(tab)}
              >
                {tab === 'Information' && 'Personal Information'}
                {tab === 'Capture' && 'Capture Vitals'}
                {tab === 'Diagnosis' && 'Diagnosis'}
                {tab === 'Conditions' && 'Conditions'}
                {tab === 'Allergy' && 'Allergy'}
                {tab === 'SOAPNotes' && 'SOAP Notes'} {/* Display name for the new tab */}
                {tab === 'Attachments' && 'Attachments'}
                {tab === 'DiagnosisModel' && 'Diagnosis Model'}
              </button>
            ))}
          </div>

          {/* Tab Content */}
          <div className="tab-content-container p-4">
            {/* Personal Information */}
            {activeTab === 'Information' && (
              <form action="#" method="get" className="space-y-4">
                <p className="text-xl font-bold text-gray-800 mb-4">Personal Information</p>
                <div>
                  <label htmlFor="name" className="block text-gray-700 font-medium mb-1">Name</label>
                  <input id="name" name="name" type="text" className="w-full p-2 border border-gray-300 rounded-md" />
                </div>
                <div>
                  <label className="block text-gray-700 font-medium mb-1">Gender</label>
                  <div className="flex items-center space-x-4">
                    <input type="radio" id="male" name="Gender" value="Male" className="mr-1" /><label htmlFor="male">Male</label>
                    <input type="radio" id="female" name="Gender" value="Female" className="mr-1" /><label htmlFor="female">Female</label>
                  </div>
                </div>
                <div>
                  <label htmlFor="patientId" className="block text-gray-700 font-medium mb-1">ID</label>
                  <input id="patientId" name="patientId" type="text" maxLength="14" className="w-full p-2 border border-gray-300 rounded-md" />
                </div>
                <div>
                  <label className="block text-gray-700 font-medium mb-1">Marital Status</label>
                  <div className="flex flex-wrap items-center space-x-4">
                    <input type="radio" id="single" name="Status" value="Single" className="mr-1" /><label htmlFor="single">Single</label>
                    <input type="radio" id="married" name="Status" value="Married" className="mr-1" /><label htmlFor="married">Married</label>
                    <input type="radio" id="widowed" name="Status" value="Widowed" className="mr-1" /><label htmlFor="widowed">Widowed</label>
                    <input type="radio" id="divorced" name="Status" value="Divorced" className="mr-1" /><label htmlFor="divorced">Divorced</label>
                  </div>
                </div>
                <div>
                  <label htmlFor="blood" className="block text-gray-700 font-medium mb-1">Blood type</label>
                  <input id="blood" name="blood" type="text" maxLength="3" className="w-full p-2 border border-gray-300 rounded-md" />
                </div>
                <div>
                  <label htmlFor="Occupation" className="block text-gray-700 font-medium mb-1">Occupation</label>
                  <input id="Occupation" name="Occupation" type="text" className="w-full p-2 border border-gray-300 rounded-md" />
                </div>
                <div>
                  <label htmlFor="Telephone" className="block text-gray-700 font-medium mb-1">Telephone</label>
                  <input id="Telephone" name="Telephone" type="tel" maxLength="11" className="w-full p-2 border border-gray-300 rounded-md" />
                </div>
                <div>
                  <label htmlFor="Email" className="block text-gray-700 font-medium mb-1">Email Address</label>
                  <input id="Email" name="Email" type="email" className="w-full p-2 border border-gray-300 rounded-md" />
                </div>
                <div>
                  <label htmlFor="Date" className="block text-gray-700 font-medium mb-1">Date Of Birth</label>
                  <input id="Date" name="Date" type="date" className="w-full p-2 border border-gray-300 rounded-md" />
                </div>
                <div>
                  <label htmlFor="Address" className="block text-gray-700 font-medium mb-1">Address</label>
                  <input id="Address" name="Address" type="text" className="w-full p-2 border border-gray-300 rounded-md" />
                </div>
                <div className="flex justify-end space-x-4 mt-6">
                  <button type="button" onClick={() => openCity('Capture')} className="bg-blue-500 hover:bg-blue-600 text-white font-bold py-2 px-4 rounded-md transition-colors duration-200">Next</button>
                  <button type="submit" className="bg-green-500 hover:bg-green-600 text-white font-bold py-2 px-4 rounded-md transition-colors duration-200">Done</button>
                </div>
              </form>
            )}

            {/* Capture Vitals */}
            {activeTab === 'Capture' && (
              <form action="#" method="get" className="space-y-4">
                <p className="text-xl font-bold text-gray-800 mb-4">Capture Vitals</p>
                <div>
                  <label htmlFor="height" className="block text-gray-700 font-medium mb-1">Height (cm)</label>
                  <input id="height" name="height" type="text" className="w-full p-2 border border-gray-300 rounded-md" /><span className="ml-2">cm</span>
                </div>
                <div>
                  <label htmlFor="weight" className="block text-gray-700 font-medium mb-1">Weight (kg)</label>
                  <input id="weight" name="weight" type="text" className="w-full p-2 border border-gray-300 rounded-md" /><span className="ml-2">kg</span>
                </div>
                <div>
                  <label htmlFor="bmi" className="block text-gray-700 font-medium mb-1">BMI</label>
                  <input id="bmi" name="bmi" type="text" className="w-full p-2 border border-gray-300 rounded-md" />
                </div>
                <div>
                  <label htmlFor="temperature" className="block text-gray-700 font-medium mb-1">Temperature (°C)</label>
                  <input id="temperature" name="temperature" type="text" className="w-full p-2 border border-gray-300 rounded-md" /><span className="ml-2">°C</span>
                </div>
                <div>
                  <label htmlFor="pulse" className="block text-gray-700 font-medium mb-1">Pulse</label>
                  <input id="pulse" name="pulse" type="text" className="w-full p-2 border border-gray-300 rounded-md" /><span className="ml-2">/min</span>
                </div>
                <div>
                  <label htmlFor="respiratoryRate" className="block text-gray-700 font-medium mb-1">Respiratory Rate</label>
                  <input id="respiratoryRate" name="respiratoryRate" type="text" className="w-full p-2 border border-gray-300 rounded-md" /><span className="ml-2">/min</span>
                </div>
                <div>
                  <label htmlFor="bloodPressure" className="block text-gray-700 font-medium mb-1">Blood Pressure</label>
                  <div className="flex items-center">
                    <input id="systolic" name="systolic" type="text" className="w-1/3 p-2 border border-gray-300 rounded-md mr-2" placeholder="Systolic" />
                    <span className="text-2xl font-bold">/</span>
                    <input id="diastolic" name="diastolic" type="text" className="w-1/3 p-2 border border-gray-300 rounded-md ml-2" placeholder="Diastolic" />
                  </div>
                </div>
                <div>
                  <label htmlFor="oxygen" className="block text-gray-700 font-medium mb-1">Arterial blood oxygen</label>
                  <input id="oxygen" name="oxygen" type="text" className="w-full p-2 border border-gray-300 rounded-md" /><span className="ml-2">%</span>
                </div>
                <div className="flex justify-end space-x-4 mt-6">
                  <button type="button" onClick={() => openCity('Information')} className="bg-gray-500 hover:bg-gray-600 text-white font-bold py-2 px-4 rounded-md transition-colors duration-200">Back</button>
                  <button type="button" onClick={() => openCity('Diagnosis')} className="bg-blue-500 hover:bg-blue-600 text-white font-bold py-2 px-4 rounded-md transition-colors duration-200">Next</button>
                  <button type="submit" className="bg-green-500 hover:bg-green-600 text-white font-bold py-2 px-4 rounded-md transition-colors duration-200">Done</button>
                </div>
              </form>
            )}

            {/* Diagnosis */}
            {activeTab === 'Diagnosis' && (
              <form action="#" method="get" className="space-y-4">
                <p className="text-xl font-bold text-gray-800 mb-4">Diagnosis</p>
                <div>
                  <label htmlFor="diseaseName" className="block text-gray-700 font-medium mb-1">Disease Name</label>
                  <input type="text" name="diseaseName" id="diseaseName" className="w-full p-2 border border-gray-300 rounded-md" />
                </div>
                <div>
                  <label htmlFor="classification" className="block text-gray-700 font-medium mb-1">Classification</label>
                  <input type="text" name="classification" id="classification" className="w-full p-2 border border-gray-300 rounded-md" />
                </div>
                <div>
                  <label htmlFor="organsHarmed" className="block text-gray-700 font-medium mb-1">Organs Get Harmed</label>
                  <input type="text" name="organsHarmed" id="organsHarmed" className="w-full p-2 border border-gray-300 rounded-md" />
                </div>
                <div>
                  <label htmlFor="lastObservation" className="block text-gray-700 font-medium mb-1">Last Observation</label>
                  <input type="text" name="lastObservation" id="lastObservation" className="w-full p-2 border border-gray-300 rounded-md" />
                </div>
                <div>
                  <label htmlFor="timesOfEnergy" className="block text-gray-700 font-medium mb-1">Times Of Energy</label>
                  <input type="text" name="timesOfEnergy" id="timesOfEnergy" className="w-full p-2 border border-gray-300 rounded-md" />
                </div>
                <div>
                  <label htmlFor="timeStamp" className="block text-gray-700 font-medium mb-1">TimeStamp</label>
                  <input id="timeStamp" name="timeStamp" type="datetime-local" className="w-full p-2 border border-gray-300 rounded-md" />
                </div>
                <div>
                  <label htmlFor="clinicalNote" className="block text-gray-700 font-medium mb-1">Clinical Note</label>
                  <textarea id="clinicalNote" name="clinicalNote" className="w-full p-2 border border-gray-300 rounded-md h-24 resize-none"></textarea>
                </div>
                <div className="flex justify-end space-x-4 mt-6">
                  <button type="button" onClick={() => openCity('Capture')} className="bg-gray-500 hover:bg-gray-600 text-white font-bold py-2 px-4 rounded-md transition-colors duration-200">Back</button>
                  <button type="button" onClick={() => openCity('Conditions')} className="bg-blue-500 hover:bg-blue-600 text-white font-bold py-2 px-4 rounded-md transition-colors duration-200">Next</button>
                  <button type="submit" className="bg-green-500 hover:bg-green-600 text-white font-bold py-2 px-4 rounded-md transition-colors duration-200">Done</button>
                </div>
              </form>
            )}

            {/* Conditions */}
            {activeTab === 'Conditions' && (
              <form action="/action_page.php" method="get" className="space-y-4">
                <p className="text-xl font-bold text-gray-800 mb-4">Add New Conditions</p>
                <div>
                  <label htmlFor="conditions" className="block text-gray-700 font-medium mb-1">Conditions</label>
                  <input type="text" name="conditions" id="conditions" className="w-full p-2 border border-gray-300 rounded-md" />
                </div>
                <div>
                  <label htmlFor="action" className="block text-gray-700 font-medium mb-1">Action</label>
                  <input type="text" name="action" id="action" className="w-full p-2 border border-gray-300 rounded-md" />
                </div>
                <div>
                  <label htmlFor="onset" className="block text-gray-700 font-medium mb-1">OnSetDate</label>
                  <input id="onset" name="onset" type="datetime-local" className="w-full p-2 border border-gray-300 rounded-md" />
                </div>
                <div>
                  <label className="block text-gray-700 font-medium mb-1">Activation</label>
                  <div className="flex items-center space-x-4">
                    <input type="radio" id="active" value="active" name="act" className="mr-1" /><label htmlFor="active">Active</label>
                    <input type="radio" id="inactive" value="inactive" name="act" className="mr-1" /><label htmlFor="inactive">Inactive</label>
                  </div>
                </div>
                <div>
                  <label htmlFor="end" className="block text-gray-700 font-medium mb-1">EndDate</label>
                  <input id="end" name="end" type="datetime-local" className="w-full p-2 border border-gray-300 rounded-md" />
                </div>
                <div className="flex justify-end space-x-4 mt-6">
                  <button type="button" onClick={() => openCity('Diagnosis')} className="bg-gray-500 hover:bg-gray-600 text-white font-bold py-2 px-4 rounded-md transition-colors duration-200">Back</button>
                  <button type="button" onClick={() => openCity('Allergy')} className="bg-blue-500 hover:bg-blue-600 text-white font-bold py-2 px-4 rounded-md transition-colors duration-200">Next</button>
                  <button type="submit" className="bg-green-500 hover:bg-green-600 text-white font-bold py-2 px-4 rounded-md transition-colors duration-200">Done</button>
                </div>
              </form>
            )}

            {/* Allergy */}
            {activeTab === 'Allergy' && (
              <form action="#" method="get" className="space-y-4">
                <h2 className="text-2xl font-bold text-blue-700 text-center mb-6">Add New Allergy</h2>
                
                {/* Allergen Type Buttons */}
                <div className="flex justify-center space-x-4 mb-6">
                  <button
                    type="button"
                    className={`checkpoint-button px-6 py-2 rounded-md font-semibold transition-colors duration-200 ${
                      activeAllergenType === 'Drug' ? 'bg-blue-500 text-white' : 'bg-gray-200 text-gray-700 hover:bg-gray-300'
                    }`}
                    onClick={() => setActiveAllergenType('Drug')}
                  >
                    Drug
                  </button>
                  <button
                    type="button"
                    className={`checkpoint-button px-6 py-2 rounded-md font-semibold transition-colors duration-200 ${
                      activeAllergenType === 'Food' ? 'bg-blue-500 text-white' : 'bg-gray-200 text-gray-700 hover:bg-gray-300'
                    }`}
                    onClick={() => setActiveAllergenType('Food')}
                  >
                    Food
                  </button>
                  <button
                    type="button"
                    className={`checkpoint-button px-6 py-2 rounded-md font-semibold transition-colors duration-200 ${
                      activeAllergenType === 'Other' ? 'bg-blue-500 text-white' : 'bg-gray-200 text-gray-700 hover:bg-gray-300'
                    }`}
                    onClick={() => setActiveAllergenType('Other')}
                  >
                    Other
                  </button>
                </div>

                {/* Main Allergy Content Grid */}
                <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
                  {/* Left Column: Allergen Checkboxes */}
                  <div className="allergen-checkboxes bg-gray-50 p-4 rounded-lg shadow-inner">
                    {activeAllergenType === 'Drug' && (
                      <div className="space-y-2">
                        {drugAllergens.map((allergen) => (
                          <label key={allergen} className="flex items-center text-gray-700 text-lg">
                            <input
                              type="checkbox"
                              name="drugAllergen"
                              value={allergen}
                              checked={selectedDrugs.includes(allergen)}
                              onChange={(e) => handleAllergenCheckboxChange(e, selectedDrugs, setSelectedDrugs, setOtherDrug)}
                              className="mr-2 h-4 w-4 text-blue-600 rounded"
                            />
                            {allergen}
                          </label>
                        ))}
                        <label className="flex items-center text-gray-700 text-lg">
                          <input
                            type="checkbox"
                            name="drugAllergen"
                            value="Other"
                            checked={selectedDrugs.includes('Other')}
                            onChange={(e) => handleAllergenCheckboxChange(e, selectedDrugs, setSelectedDrugs, setOtherDrug)}
                            className="mr-2 h-4 w-4 text-blue-600 rounded"
                          />
                          Other:
                          {selectedDrugs.includes('Other') && (
                            <input
                              type="text"
                              value={otherDrug}
                              onChange={(e) => setOtherDrug(e.target.value)}
                              className="ml-2 p-1 border border-gray-300 rounded-md w-40 text-base bg-white/50"
                              placeholder="Specify other drug"
                            />
                          )}
                        </label>
                      </div>
                    )}

                    {activeAllergenType === 'Food' && (
                      <div className="space-y-2">
                        {foodAllergens.map((allergen) => (
                          <label key={allergen} className="flex items-center text-gray-700 text-lg">
                            <input
                              type="checkbox"
                              name="foodAllergen"
                              value={allergen}
                              checked={selectedFoods.includes(allergen)}
                              onChange={(e) => handleAllergenCheckboxChange(e, selectedFoods, setSelectedFoods, setOtherFood)}
                              className="mr-2 h-4 w-4 text-blue-600 rounded"
                            />
                            {allergen}
                          </label>
                        ))}
                        <label className="flex items-center text-gray-700 text-lg">
                          <input
                            type="checkbox"
                            name="foodAllergen"
                            value="Other"
                            checked={selectedFoods.includes('Other')}
                            onChange={(e) => handleAllergenCheckboxChange(e, selectedFoods, setSelectedFoods, setOtherFood)}
                            className="mr-2 h-4 w-4 text-blue-600 rounded"
                          />
                          Other:
                          {selectedFoods.includes('Other') && (
                            <input
                              type="text"
                              value={otherFood}
                              onChange={(e) => setOtherFood(e.target.value)}
                              className="ml-2 p-1 border border-gray-300 rounded-md w-40 text-base bg-white/50"
                              placeholder="Specify other food"
                            />
                          )}
                        </label>
                      </div>
                    )}

                    {activeAllergenType === 'Other' && (
                      <div className="space-y-2">
                        {otherAllergens.map((allergen) => (
                          <label key={allergen} className="flex items-center text-gray-700 text-lg">
                            <input
                              type="checkbox"
                              name="otherAllergen"
                              value={allergen}
                              checked={selectedOtherAllergens.includes(allergen)}
                              onChange={(e) => handleAllergenCheckboxChange(e, selectedOtherAllergens, setSelectedOtherAllergens, setOtherOtherAllergen)}
                              className="mr-2 h-4 w-4 text-blue-600 rounded"
                            />
                            {allergen}
                          </label>
                        ))}
                        <label className="flex items-center text-gray-700 text-lg">
                          <input
                            type="checkbox"
                            name="otherAllergen"
                            value="Other"
                            checked={selectedOtherAllergens.includes('Other')}
                            onChange={(e) => handleAllergenCheckboxChange(e, selectedOtherAllergens, setSelectedOtherAllergens, setOtherOtherAllergen)}
                            className="mr-2 h-4 w-4 text-blue-600 rounded"
                          />
                          Other:
                          {selectedOtherAllergens.includes('Other') && (
                            <input
                              type="text"
                              value={otherOtherAllergen}
                              onChange={(e) => setOtherOtherAllergen(e.target.value)}
                              className="ml-2 p-1 border border-gray-300 rounded-md w-40 text-base bg-white/50"
                              placeholder="Specify other allergen"
                            />
                          )}
                        </label>
                      </div>
                    )}
                  </div>

                  {/* Right Column: Reaction Checkboxes */}
                  <div className="reaction-checkboxes bg-gray-50 p-4 rounded-lg shadow-inner">
                    <strong className="block text-xl font-bold text-gray-800 mb-4">Reaction</strong>
                    <p className="text-gray-600 text-sm mb-4">(check all that apply):</p>
                    <div className="grid grid-cols-1 sm:grid-cols-2 gap-x-4 gap-y-2">
                      {reactions.map((reaction) => (
                        <label key={reaction} className="flex items-center text-gray-700 text-lg">
                          <input
                            type="checkbox"
                            name="reaction"
                            value={reaction}
                            checked={selectedReactions.includes(reaction)}
                            onChange={handleReactionCheckboxChange}
                            className="mr-2 h-4 w-4 text-blue-600 rounded"
                          />
                          {reaction}
                        </label>
                      ))}
                      <label className="flex items-center text-gray-700 text-lg col-span-full">
                        <input
                          type="checkbox"
                          name="reaction"
                          value="Other"
                          checked={selectedReactions.includes('Other')}
                          onChange={handleReactionCheckboxChange}
                          className="mr-2 h-4 w-4 text-blue-600 rounded"
                        />
                        Other:
                        {selectedReactions.includes('Other') && (
                          <input
                            type="text"
                            value={otherReaction}
                            onChange={(e) => setOtherReaction(e.target.value)}
                            className="ml-2 p-1 border border-gray-300 rounded-md w-40 text-base bg-white/50"
                            placeholder="Specify other reaction"
                          />
                        )}
                      </label>
                    </div>
                  </div>
                </div>

                {/* Severity and Comment */}
                <div className="mt-8 bg-gray-50 p-4 rounded-lg shadow-inner">
                  <strong className="block text-xl font-bold text-gray-800 mb-4">Severity</strong>
                  <div className="flex flex-wrap items-center space-x-6 mb-4">
                    <label className="flex items-center text-gray-700 text-lg">
                      <input
                        type="radio"
                        name="severity"
                        value="Mild"
                        checked={severity === 'Mild'}
                        onChange={(e) => setSeverity(e.target.value)}
                        className="mr-2 h-4 w-4 text-blue-600"
                      />
                      Mild
                    </label>
                    <label className="flex items-center text-gray-700 text-lg">
                      <input
                        type="radio"
                        name="severity"
                        value="Moderate"
                        checked={severity === 'Moderate'}
                        onChange={(e) => setSeverity(e.target.value)}
                        className="mr-2 h-4 w-4 text-blue-600"
                      />
                      Moderate
                    </label>
                    <label className="flex items-center text-gray-700 text-lg">
                      <input
                        type="radio"
                        name="severity"
                        value="Severe"
                        checked={severity === 'Severe'}
                        onChange={(e) => setSeverity(e.target.value)}
                        className="mr-2 h-4 w-4 text-blue-600"
                      />
                      Severe
                    </label>
                  </div>
                  <label htmlFor="allergyComment" className="block text-gray-700 text-xl font-bold mb-2">Comment</label>
                  <textarea
                    id="allergyComment"
                    name="allergyComment"
                    value={allergyComment}
                    onChange={(e) => setAllergyComment(e.target.value)}
                    className="w-full p-2 border border-gray-300 rounded-md h-24 resize-none bg-white/50"
                    placeholder="Add comments about the allergy..."
                  ></textarea>
                </div>

                <div className="flex justify-end space-x-4 mt-6">
                  <button type="button" onClick={() => openCity('Conditions')} className="bg-gray-500 hover:bg-gray-600 text-white font-bold py-2 px-4 rounded-md transition-colors duration-200">Back</button>
                  <button type="button" onClick={() => openCity('SOAPNotes')} className="bg-blue-500 hover:bg-blue-600 text-white font-bold py-2 px-4 rounded-md transition-colors duration-200">Next</button> {/* Updated Next button */}
                  <button type="submit" className="bg-green-500 hover:bg-green-600 text-white font-bold py-2 px-4 rounded-md transition-colors duration-200">Done</button>
                </div>
              </form>
            )}

            {/* NEW: SOAP Notes Tab Content */}
            {activeTab === 'SOAPNotes' && (
              <form action="#" method="get" className="space-y-4">
                <p className="text-xl font-bold text-gray-800 mb-4">SOAP Notes</p>
                <div>
                  <label htmlFor="subjective" className="block text-gray-700 font-medium mb-1">Subjective</label>
                  <textarea 
                    id="subjective" 
                    name="subjective" 
                    value={subjectiveNote} 
                    onChange={(e) => setSubjectiveNote(e.target.value)} 
                    className="w-full p-2 border border-gray-300 rounded-md h-24 resize-none" 
                    placeholder="Patient's chief complaint and history..."
                  ></textarea>
                </div>
                <div>
                  <label htmlFor="objective" className="block text-gray-700 font-medium mb-1">Objective</label>
                  <textarea 
                    id="objective" 
                    name="objective" 
                    value={objectiveNote} 
                    onChange={(e) => setObjectiveNote(e.target.value)} 
                    className="w-full p-2 border border-gray-300 rounded-md h-24 resize-none" 
                    placeholder="Physical exam findings, lab results, imaging..."
                  ></textarea>
                </div>
                <div>
                  <label htmlFor="assessment" className="block text-gray-700 font-medium mb-1">Assessment</label>
                  <textarea 
                    id="assessment" 
                    name="assessment" 
                    value={assessmentNote} 
                    onChange={(e) => setAssessmentNote(e.target.value)} 
                    className="w-full p-2 border border-gray-300 rounded-md h-24 resize-none" 
                    placeholder="Diagnosis or differential diagnosis..."
                  ></textarea>
                </div>
                <div>
                  <label htmlFor="plan" className="block text-gray-700 font-medium mb-1">Plan</label>
                  <textarea 
                    id="plan" 
                    name="plan" 
                    value={planNote} 
                    onChange={(e) => setPlanNote(e.target.value)} 
                    className="w-full p-2 border border-gray-300 rounded-md h-24 resize-none" 
                    placeholder="Treatment plan, medications, follow-up..."
                  ></textarea>
                </div>
                <div className="flex justify-end space-x-4 mt-6">
                  <button type="button" onClick={() => openCity('Allergy')} className="bg-gray-500 hover:bg-gray-600 text-white font-bold py-2 px-4 rounded-md transition-colors duration-200">Back</button>
                  <button type="button" onClick={() => openCity('Attachments')} className="bg-blue-500 hover:bg-blue-600 text-white font-bold py-2 px-4 rounded-md transition-colors duration-200">Next</button>
                  <button type="submit" className="bg-green-500 hover:bg-green-600 text-white font-bold py-2 px-4 rounded-md transition-colors duration-200">Done</button>
                </div>
              </form>
            )}

            {/* Attachments */}
            {activeTab === 'Attachments' && (
              <form onSubmit={(e) => e.preventDefault()} className="space-y-6">
                <p className="text-xl font-bold text-gray-800 mb-4">Attachments</p>

                {/* Attachment 1 */}
                <div className="flex flex-col md:flex-row items-center md:items-start space-y-4 md:space-y-0 md:space-x-4">
                  <div className="w-48 h-36 bg-gray-100 border border-gray-300 rounded-md flex items-center justify-center relative overflow-hidden">
                    {/* Display attachment 1 preview */}
                    <img src={attachment1Preview} alt="Upload attachment" className="w-36 h-32 object-contain" />
                  </div>
                  <textarea
                    id="note1"
                    name="note1"
                    placeholder="Write Comment"
                    className="flex-1 p-2 border border-gray-300 rounded-md h-36 resize-none"
                    value={note1} // Bind value to state
                    onChange={(e) => setNote1(e.target.value)} // Update state on change
                  ></textarea>
                  <div className="relative">
                    <input
                      type="file"
                      id="attachment1UploadFile" // Unique ID
                      name="attachment1UploadFile" // Unique name
                      className="absolute inset-0 opacity-0 cursor-pointer z-10"
                      onChange={(e) => handleAttachmentFileChange(e, setAttachment1Preview)}
                    />
                    <label htmlFor="attachment1UploadFile" className="bg-blue-500 hover:bg-blue-600 text-white font-bold py-2 px-4 rounded-md transition-colors duration-200 cursor-pointer">
                      Upload file
                    </label>
                  </div>
                  <button
                    type="button"
                    onClick={clearAttachment1Form} // Call the new clear function
                    className="bg-gray-200 hover:bg-gray-300 text-gray-800 font-bold py-2 px-4 rounded-md transition-colors duration-200 cursor-pointer"
                  >
                    Clear Form
                  </button>
                </div>

                {/* Attachment 2 */}
                <div className="flex flex-col md:flex-row items-center md:items-start space-y-4 md:space-y-0 md:space-x-4 mt-6">
                  <div className="w-48 h-36 bg-gray-100 border border-gray-300 rounded-md flex items-center justify-center relative overflow-hidden">
                    {/* Display attachment 2 preview */}
                    <img src={attachment2Preview} alt="Upload attachment" className="w-36 h-32 object-contain" />
                  </div>
                  <textarea
                    id="note2"
                    name="note2"
                    placeholder="Write Comment"
                    className="flex-1 p-2 border border-gray-300 rounded-md h-36 resize-none"
                    value={note2} // Bind value to state
                    onChange={(e) => setNote2(e.target.value)} // Update state on change
                  ></textarea>
                  <div className="relative">
                    <input
                      type="file"
                      id="attachment2UploadFile" // Unique ID
                      name="attachment2UploadFile" // Unique name
                      className="absolute inset-0 opacity-0 cursor-pointer z-10"
                      onChange={(e) => handleAttachmentFileChange(e, setAttachment2Preview)}
                    />
                    <label htmlFor="attachment2UploadFile" className="bg-blue-500 hover:bg-blue-600 text-white font-bold py-2 px-4 rounded-md transition-colors duration-200 cursor-pointer">
                      Upload file
                    </label>
                  </div>
                  <button
                    type="button"
                    onClick={clearAttachment2Form} // Call the new clear function
                    className="bg-gray-200 hover:bg-gray-300 text-gray-800 font-bold py-2 px-4 rounded-md transition-colors duration-200 cursor-pointer"
                  >
                    Clear Form
                  </button>
                </div>

                <div className="flex justify-end space-x-4 mt-6">
                  <button type="button" onClick={() => openCity('SOAPNotes')} className="bg-gray-500 hover:bg-gray-600 text-white font-bold py-2 px-4 rounded-md transition-colors duration-200">Back</button> {/* Updated Back button */}
                  <button type="button" onClick={() => openCity('DiagnosisModel')} className="bg-blue-500 hover:bg-blue-600 text-white font-bold py-2 px-4 rounded-md transition-colors duration-200">Next</button>
                  <button type="submit" className="bg-green-500 hover:bg-green-600 text-white font-bold py-2 px-4 rounded-md transition-colors duration-200">Done</button>
                </div>
              </form>
            )}

            {/* Diagnosis Model */}
            {activeTab === 'DiagnosisModel' && (
              <form action="/action_page.php" method="get" className="space-y-6"> {/* Increased spacing */}
                <p className="text-xl font-bold text-gray-800 mb-4">Diagnosis Model</p>
                
                {/* Main Image Upload */}
                <div className="bg-gray-50 p-4 rounded-lg shadow-inner">
                  <h5 className="text-gray-800 text-lg font-bold mb-2">Choose An Image File For Classification/Segmentation</h5>
                  <div className="flex items-center space-x-4 border border-gray-300 rounded-md p-4">
                    <img src={diagnosisModelImage} alt="Upload" className="w-24 h-20 object-contain" />
                    <div className="flex-1">
                      <p className="text-gray-600 text-sm mb-2">Drag and drop file here or click to browse. Limit 200MB Per file. JPG, PNG, JPEG</p>
                      <input
                        type="file"
                        id="diagnosisModelBrowse"
                        name="diagnosisModelBrowse"
                        hidden
                        onChange={handleDiagnosisModelFileChange}
                      />
                      <label htmlFor="diagnosisModelBrowse" className="inline-block bg-blue-500 hover:bg-blue-600 text-white font-bold py-2 px-4 rounded-md cursor-pointer transition-colors duration-200">
                        Browse Files
                      </label>
                    </div>
                  </div>
                </div>

                {/* Model Diagnosis Report */}
                <div className="bg-gray-50 p-4 rounded-lg shadow-inner">
                  <label htmlFor="modelReport" className="block text-gray-700 font-medium mb-2">Model Diagnosis Report</label>
                  <textarea
                    id="modelReport"
                    name="modelReport"
                    placeholder="The model's diagnosis report will appear here after image analysis..."
                    className="w-full p-2 border border-gray-300 rounded-md h-48 resize-none bg-white/50"
                    value={modelReport}
                    onChange={(e) => setModelReport(e.target.value)} // Allow manual editing if needed
                    readOnly // Make it read-only if you only want model output
                  ></textarea>
                </div>

                {/* NEW: Heatmap Image Upload and Comment */}
                <div className="bg-gray-50 p-4 rounded-lg shadow-inner">
                  <h5 className="text-gray-800 text-lg font-bold mb-2">Heatmap Image (AI Interpretation)</h5>
                  <div className="flex flex-col sm:flex-row items-center space-x-0 sm:space-x-4 space-y-4 sm:space-y-0 border border-gray-300 rounded-md p-4">
                    <img src={heatmapImage} alt="Heatmap Preview" className="w-36 h-28 object-contain" />
                    <div className="flex-1 w-full">
                      <p className="text-gray-600 text-sm mb-2">Upload heatmap image generated by AI model.</p>
                      <input
                        type="file"
                        id="heatmapUpload"
                        name="heatmapUpload"
                        hidden
                        onChange={handleHeatmapFileChange}
                      />
                      <label htmlFor="heatmapUpload" className="inline-block bg-blue-500 hover:bg-blue-600 text-white font-bold py-2 px-4 rounded-md cursor-pointer transition-colors duration-200">
                        Browse Heatmap
                      </label>
                    </div>
                  </div>
                  <label htmlFor="heatmapComment" className="block text-gray-700 font-medium mt-4 mb-2">Heatmap Comment:</label>
                  <textarea
                    id="heatmapComment"
                    name="heatmapComment"
                    placeholder="Comment on heatmap interpretation..."
                    className="w-full p-2 border border-gray-300 rounded-md h-24 resize-none bg-white/50"
                    value={heatmapComment}
                    onChange={(e) => setHeatmapComment(e.target.value)}
                  ></textarea>
                </div>

                {/* NEW: Segmentation Mask Image Upload and Comment */}
                <div className="bg-gray-50 p-4 rounded-lg shadow-inner">
                  <h5 className="text-gray-800 text-lg font-bold mb-2">Segmentation Mask Image (AI Interpretation)</h5>
                  <div className="flex flex-col sm:flex-row items-center space-x-0 sm:space-x-4 space-y-4 sm:space-y-0 border border-gray-300 rounded-md p-4">
                    <img src={segmentationMaskImage} alt="Segmentation Mask Preview" className="w-36 h-28 object-contain" />
                    <div className="flex-1 w-full">
                      <p className="text-gray-600 text-sm mb-2">Upload segmentation mask image generated by AI model.</p>
                      <input
                        type="file"
                        id="segmentationMaskUpload"
                        name="segmentationMaskUpload"
                        hidden
                        onChange={handleSegmentationMaskFileChange}
                      />
                      <label htmlFor="segmentationMaskUpload" className="inline-block bg-blue-500 hover:bg-blue-600 text-white font-bold py-2 px-4 rounded-md cursor-pointer transition-colors duration-200">
                        Browse Mask
                      </label>
                    </div>
                  </div>
                  <label htmlFor="segmentationMaskComment" className="block text-gray-700 font-medium mt-4 mb-2">Segmentation Mask Comment:</label>
                  <textarea
                    id="segmentationMaskComment"
                    name="segmentationMaskComment"
                    placeholder="Comment on segmentation mask interpretation..."
                    className="w-full p-2 border border-gray-300 rounded-md h-24 resize-none bg-white/50"
                    value={segmentationMaskComment}
                    onChange={(e) => setSegmentationMaskComment(e.target.value)}
                  ></textarea>
                </div>


                <div className="flex justify-end space-x-4 mt-6">
                  <button type="button" onClick={() => openCity('Attachments')} className="bg-gray-500 hover:bg-gray-600 text-white font-bold py-2 px-4 rounded-md transition-colors duration-200">Back</button>
                  {/* Button to trigger report generation (for demonstration) */}
                  <button type="button" onClick={generateModelReport} className="bg-blue-500 hover:bg-blue-600 text-white font-bold py-2 px-4 rounded-md transition-colors duration-200">
                    Generate Report (Simulated)
                  </button>
                  {/* Button to clear the report */}
                  <button type="button" onClick={clearModelReport} className="bg-gray-200 hover:bg-gray-300 text-gray-800 font-bold py-2 px-4 rounded-md transition-colors duration-200">
                    Clear Report
                  </button>
                  <button type="submit" className="bg-green-500 hover:bg-green-600 text-white font-bold py-2 px-4 rounded-md transition-colors duration-200">Done</button>
                </div>
              </form>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default RegisterPatient;
